<template>
  <section>
    <v-container>
      <div class="contact">
        <v-row>
          <div class="heading">
            <span>Contactez-nous!</span>
            <p>
              Si vous êtes à la recherche d’informations sur Sportopia <br />
              prenez contact avec nous !
            </p>
          </div>
        </v-row>
        <v-form>
          <v-row>
            <v-col xs="12" sm="12" md="6" lg="6" class="responsive-pad">
              <v-text-field
                v-model="clientMessage.name"
                label="Nom & prénom"
                required
                outlined
                prepend-inner-icon="mdi-account"
              ></v-text-field>
              <v-text-field
                v-model="clientMessage.email"
                label="E-mail"
                required
                outlined
                prepend-inner-icon="mdi-email"
              ></v-text-field>
              <v-text-field
                v-model="clientMessage.phone"
                label="Téléphone"
                required
                outlined
                prepend-inner-icon="mdi-phone"
                maxlength="8"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="6" class="responsive-pad">
              <v-textarea
                v-model="clientMessage.message"
                prepend-inner-icon="mdi-comment"
                label="Message"
                rows="9"
                auto-grow
                outlined
                required
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <button type="button" class="sendForm" @click="onSendClick">Soumettre</button>
          </v-row>
        </v-form>
      </div>
    </v-container>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AppContact",
  data: () => ({
    clientMessage: {
      message: "",
      type: "message",
      email: "",
      name: "",
    },
  }),
  methods: {
    ...mapActions(["sendClientMessage"]),
    onSendClick() {
      if (this.clientMessage.email !== "")
        this.sendClientMessage(this.clientMessage);
    },
  },
};
</script>

<style scoped>
section {
  background: #f5f5f5;
  padding: 50px 0;
}
.contact {
  background: #fff;
  border-top-left-radius: 50px;
  border-bottom-right-radius: 50px;
  padding: 100px;
}
.heading {
  margin: 0 auto 35px auto;
  text-align: center;
}
.heading span {
  font-size: 28px;
  font-weight: 600;
  display: block;
}
.heading p {
  font-size: 16px;
  font-weight: normal;
}
form {
  width: 100%;
}
.v-input__slot {
  margin-bottom: 11px;
}
.sendForm {
  color: #fff;
  background: #e91e24;
  padding: 10px 30px;
  border-radius: 50px;
  width: 100%;
  text-align: center;
}
.col {
  flex-basis: auto !important;
}
@media (max-width: 980px) {
  .contact {
    padding: 50px;
  }
  .v-textarea {
    margin-top: -20px !important;
  }
}
</style>